<template>
  <div class="page-content">
    <router-view></router-view>
  </div>
</template>
<script>
  require('material-design-lite')
</script>

<style>
  .page-header {
    padding-left: 20px;
  }

  #toolbar-title {
    margin-left: 20px;
  }
  @import url('https://code.getmdl.io/1.3.0/material.teal-orange.min.css');
</style>



// WEBPACK FOOTER //
// src/App.vue